import { CarePlanNoteProblemResponse } from '~/lib/types/carePlan/carePlans';
import {
  ChakraBox,
  ChakraFlex,
  ChakraListItem,
  ChakraUnorderedList,
  Text,
} from '@equip.health/ui';
import { PatientNoteItemCarePlanStatusHistory } from './PatientNoteItemCarePlanStatusHistory';
import { CarePlanGoalStatus } from '~/lib/types/carePlan/CarePlanGoalStatus';
import { ProblemTypeCode } from '~/lib/types/carePlan/ProblemTypeCode';

type Props = {
  problem: CarePlanNoteProblemResponse;
};
export const PatientNoteItemCarePlanGoal = ({ problem }: Props) => {
  const goal = problem.goals[0];

  const description =
    goal.description ||
    goal.descriptionDetails?.description ||
    problem.description;
  const isNotAssessed = goal.status.code === CarePlanGoalStatus.NOT_ASSESSED;

  const isMedPsychEntry =
    problem.problemType != null &&
    problem.problemType !== ProblemTypeCode.EATING_DISORDER &&
    problem.manifestations.length === 0 &&
    !problem.frequency;

  return (
    <ChakraFlex
      width="100%"
      direction="column"
      justifyContent="center"
      data-testid={`patient-note-item__goal-card__${goal.id}`}
    >
      <ChakraFlex alignItems="center" gap="12px">
        <Text
          variant="captionMedium"
          data-testid={`patient-note-item__goal-title__${goal.id}`}
        >
          {goal.pathwayGoal.label}
        </Text>
        <PatientNoteItemCarePlanStatusHistory
          id={goal.id}
          status={goal.status}
          statusHistories={goal.statusHistories}
        />
      </ChakraFlex>
      {!isNotAssessed && description && (
        <ChakraBox
          marginTop="8px"
          padding="12px"
          borderRadius="12px"
          bgColor="neutral.background.secondary"
          data-testid={`patient-note-item__goal-description__${goal.id}`}
        >
          <Text variant="caption">{description}</Text>
        </ChakraBox>
      )}
      {!isNotAssessed && problem.manifestations.length > 0 && (
        <ChakraUnorderedList marginTop="8px">
          {problem.manifestations.map((manifestation) => {
            let labelWithFrequencyIfPresent =
              manifestation.pathwayManifestation.providerFacingLanguage ||
              manifestation.pathwayManifestation.label;
            if (manifestation.frequency?.label) {
              labelWithFrequencyIfPresent +=
                ': ' + manifestation.frequency.label;
            }
            return (
              <ChakraListItem key={manifestation.pathwayManifestation.code}>
                <Text variant="caption">{labelWithFrequencyIfPresent}</Text>
              </ChakraListItem>
            );
          })}
        </ChakraUnorderedList>
      )}
      {!isNotAssessed &&
        problem.manifestations.length === 0 &&
        !isMedPsychEntry && (
          <ChakraUnorderedList marginTop="8px">
            <ChakraListItem data-testid="patient-note-problem-row">
              <ChakraFlex>
                <Text variant="caption" flex="0 0 calc(50% - 0.5em)">
                  {problem.pathwayProblem.providerFacingLanguage ||
                    problem.pathwayProblem.label}
                </Text>
                {problem.frequency && (
                  <Text variant="caption">{problem.frequency.label}</Text>
                )}
              </ChakraFlex>
            </ChakraListItem>
          </ChakraUnorderedList>
        )}
    </ChakraFlex>
  );
};
